import React from "react";
import { Container } from "react-bootstrap";
import Particle from "./Particle";

const legalStyle = {
  padding: "50px 20px",
  textAlign: "left",
  backgroundColor: "rgba(255, 255, 255, 0.95)",
  borderRadius: "10px",
  marginTop: "120px",
  color: "#333",
};

const faqItemStyle = { marginBottom: "1.2em" };
const faqLabelStyle = { display: "block", marginBottom: "0.3em", color: "#222" };

function SupportPurpleTrap() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <div className="legal-content" style={legalStyle}>
          <h1 style={{ textAlign: "center", marginBottom: "10px", color: "#2c3e50" }}>
            PurpleTrap
          </h1>
          <p style={{ textAlign: "center", color: "#666", marginBottom: "30px" }}>
            Support & Help
          </p>

          <h3>About PurpleTrap</h3>
          <p>
            PurpleTrap is a single-player color-matching puzzle game for iOS. No account
            or sign-in is required — your progress and high score are stored only on your device.
          </p>

          <h3>Frequently Asked Questions</h3>

          <div style={faqItemStyle}>
            <strong style={faqLabelStyle}>How do I reset my high score?</strong>
            Uninstalling and reinstalling the App will clear all local game data, including your high score.
          </div>

          <div style={faqItemStyle}>
            <strong style={faqLabelStyle}>I purchased "Remove Ads" but ads are still showing. What should I do?</strong>
            Try the "Restore Purchases" option in the App's settings. If the issue persists, make sure
            you are signed in with the same Apple ID used for the original purchase, then contact us via email.
          </div>

          <div style={faqItemStyle}>
            <strong style={faqLabelStyle}>My Game Center score isn't showing on the leaderboard.</strong>
            Ensure Game Center is enabled in your iOS Settings and that you are signed in with your Apple ID.
            Leaderboard updates may take a few minutes to appear.
          </div>

          <div style={faqItemStyle}>
            <strong style={faqLabelStyle}>How do I request a refund?</strong>
            In-App purchases are handled by Apple. You can request a refund through{" "}
            <a href="https://reportaproblem.apple.com" target="_blank" rel="noreferrer">
              reportaproblem.apple.com
            </a>.
          </div>

          <div style={faqItemStyle}>
            <strong style={faqLabelStyle}>How do I delete my data?</strong>
            PurpleTrap does not store any personal data on our servers. All game data is local to your device —
            simply uninstall the App to remove it. Your Game Center data is managed by Apple and can be
            controlled from your iOS Game Center settings.
          </div>

          <hr style={{ margin: "30px 0" }} />

          <h3>Contact Support</h3>
          <p style={{ textAlign: "center" }}>
            Have a question, found a bug, or want to suggest a feature?
          </p>
          <p style={{ textAlign: "center" }}>
            <a href="mailto:sozdemircim@gmail.com">sozdemircim@gmail.com</a>
          </p>
        </div>
      </Container>
    </Container>
  );
}

export default SupportPurpleTrap;
